import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "@/context/Context";
import MetaComponent from "@/components/common/MetaComponent";
import Preloader from "@/components/common/Preloader";
import UserManagement from "./UserManagement";
import CourseManagement from "./CourseManagement";
import FreeDownloadsManagement from "./FreeDownloadsManagement";
import HomeCarouselManagement from "./HomeCarouselManagement";
import "./AdminStyles.css";

const metadata = {
  title: "Admin Dashboard || gvkEDU: Pioneer in pharmacy education",
  description: "Admin dashboard for gvkEDU platform management and configuration.",
};

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState(1);
  const { loggedIn, loggedInUser } = useAuthContext();
  const navigate = useNavigate();
  const tabs = ["User Settings", "Course Settings", "Free Downloads", "Home Carousel"];

  // Check authentication on component mount
  useEffect(() => {
    if (!loggedIn || !loggedInUser || loggedInUser.role !== 'admin') {
      console.warn('Admin access denied - redirecting to home');
      navigate('/');
    }
  }, [loggedIn, loggedInUser, navigate]);

  // Don't render if not authenticated as admin
  if (!loggedIn || !loggedInUser || loggedInUser.role !== 'admin') {
    return (
      <div className="main-content">
        <div className="content-wrapper js-content-wrapper overflow-hidden">
          <div className="container">
            <div className="row justify-center items-center" style={{ minHeight: '60vh' }}>
              <div className="col-auto">
                <div className="text-center">
                  <h2 className="text-30 lh-15 fw-700">Access Denied</h2>
                  <p className="text-light-1 mt-5">Admin privileges required to access this page.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-content">
      <MetaComponent meta={metadata} />
      <Preloader />

      <div className="content-wrapper js-content-wrapper overflow-hidden">
        {/* Horizontal Tabs */}
        <section className="layout-pt-md">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="rounded-16 bg-white shadow-4 h-100">
                  <div className="tabs -active-purple-2 js-tabs pt-0">
                    <div className="tabs__controls d-flex x-gap-30 y-gap-20 flex-wrap items-center pt-20 px-30 border-bottom-light js-tabs-controls">
                      {tabs.map((tab, i) => (
                        <button
                          key={i}
                          onClick={() => setActiveTab(i + 1)}
                          className={`tabs__button text-light-1 js-tabs-button ${
                            activeTab === i + 1 ? "is-active" : ""
                          }`}
                          type="button"
                        >
                          {tab}
                        </button>
                      ))}
                    </div>

                    <div className="tabs__content py-30 px-30 js-tabs-content">
                      {/* User Settings Tab Content */}
                      <div className={`tabs__pane -tab-item-1 ${activeTab === 1 ? "is-active" : ""}`}>
                        <UserManagement />
                      </div>

                      {/* Course Settings Tab Content */}
                      <div className={`tabs__pane -tab-item-2 ${activeTab === 2 ? "is-active" : ""}`}>
                        <CourseManagement />
                      </div>

                      {/* Free Downloads Tab Content */}
                      <div className={`tabs__pane -tab-item-3 ${activeTab === 3 ? "is-active" : ""}`}>
                        <FreeDownloadsManagement />
                      </div>

                      {/* Home Carousel Tab Content */}
                      <div className={`tabs__pane -tab-item-4 ${activeTab === 4 ? "is-active" : ""}`}>
                        <HomeCarouselManagement />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default AdminDashboard; 